/**
 * Action types for audit logs filter
 */
export const ACTION_TYPES = [
  { label: "All Actions", value: "ALL" },
  { label: "Create", value: "CREATE" },
  { label: "Read", value: "READ" },
  { label: "Update", value: "UPDATE" },
  { label: "Delete", value: "DELETE" },
  { label: "Export", value: "EXPORT" },
];

/**
 * Resource types for audit logs filter
 */
export const RESOURCE_TYPES = [
  { label: "All Resources", value: "ALL" },
  { label: "Patient", value: "patient" },
  { label: "File", value: "file" },
  { label: "Template", value: "template" },
  { label: "User", value: "user" },
  { label: "Appointment", value: "appointment" },
];

/**
 * Badge styles for action types
 */
export const ACTION_BADGE_STYLES = {
  CREATE: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  READ: "bg-sky-50 text-sky-700 ring-sky-200",
  UPDATE: "bg-amber-50 text-amber-700 ring-amber-200",
  DELETE: "bg-red-50 text-red-700 ring-red-200",
  EXPORT: "bg-purple-50 text-purple-700 ring-purple-200",
};

/**
 * Badge styles for status
 */
export const STATUS_STYLES = {
  SUCCESS: "bg-emerald-50 text-emerald-700",
  FAILURE: "bg-red-50 text-red-700",
};

/**
 * Get Tailwind CSS classes for action badge
 * @param {string} actionType - Action type (CREATE, READ, UPDATE, DELETE, EXPORT)
 * @returns {string} - Tailwind CSS classes
 */
export function getActionBadgeStyle(actionType) {
  return (
    ACTION_BADGE_STYLES[actionType] ||
    "bg-slate-50 text-slate-700 ring-slate-200"
  );
}

/**
 * Get Tailwind CSS classes for status badge
 * @param {string} status - Status (SUCCESS, FAILURE)
 * @returns {string} - Tailwind CSS classes
 */
export function getStatusBadgeStyle(status) {
  return STATUS_STYLES[status] || "bg-slate-50 text-slate-700";
}

/**
 * Format resource type and ID for display
 * @param {string} resourceType - Resource type (patient, file, template, user, appointment)
 * @param {string} resourceId - Resource UUID
 * @returns {string} - Formatted display string
 */
export function formatResourceDisplay(resourceType, resourceId) {
  const typeLabel = resourceType
    ? resourceType.charAt(0).toUpperCase() + resourceType.slice(1)
    : "Unknown";
  const shortId = resourceId ? resourceId.substring(0, 8) : "-";
  return `${typeLabel} (${shortId}...)`;
}

/**
 * Get date 7 days ago in ISO format (YYYY-MM-DD)
 * @returns {string} - ISO date string
 */
export function getDefaultStartDate() {
  const date = new Date();
  date.setDate(date.getDate() - 7);
  return date.toISOString().split("T")[0];
}

/**
 * Get today's date in ISO format (YYYY-MM-DD)
 * @returns {string} - ISO date string
 */
export function getDefaultEndDate() {
  return new Date().toISOString().split("T")[0];
}

/**
 * Format ISO timestamp to readable format
 * @param {string} isoString - ISO timestamp string
 * @returns {string} - Formatted date/time string
 */
export function formatTimestamp(isoString) {
  if (!isoString) return "-";
  try {
    const date = new Date(isoString);
    return date.toLocaleString();
  } catch {
    return isoString;
  }
}
